import React from 'react';
import { cn } from '@/shadcn/lib/utils';
import { Skeleton } from '@/shadcn/components/ui/skeleton';

interface GridSkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  count: number;
  itemClassName?: string;
}

const GridSkeleton = React.forwardRef<HTMLDivElement, GridSkeletonProps>(
  ({ count, className, itemClassName, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4', // default grid layout
        className
      )}
      {...props}
    >
      {Array.from({ length: count }).map((_, index) => (
        <Skeleton
          key={index}
          className={cn(
            'h-[400px] w-full rounded-lg', // sensible default dimensions
            itemClassName
          )}
          aria-label={`Loading item ${index + 1}`}
        />
      ))}
    </div>
  )
);

GridSkeleton.displayName = 'GridSkeleton';

export { GridSkeleton };
